import { useState, useEffect } from 'react';

export default function useGeolocation() {
  const [location, setLocation] = useState({
    lat: 52.3614285,
    lng: 4.8982938,
    isDefault: true
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser');
      return;
    }

    setIsLoading(true);
    setError(null);
    
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          isDefault: false
        });
        setIsLoading(false);
      },
      (err) => {
        setError(`Unable to retrieve location: ${err.message}`);
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    // Try to get location automatically on component mount
    getCurrentLocation();
  }, []);

  return {
    location,
    error,
    isLoading,
    getCurrentLocation
  };
}